import React from 'react';
import MenuWithLogin from '../templates/MenuWithLogin'
import CLEForm from '../components/container/CLEForm'
import { useEffect, useState } from 'react';
import axios from 'axios';
import Typography from '@material-ui/core/Typography'

export default function CLECredit(props) {
  const [videoDataRaw, setVideoDataRaw] = useState(null);
  const [videoData, setVideoData] = useState(null);

  useEffect(() => {
    console.log(`Fetching (GET) '/law/api/online-cle/OnlineCLE_Videos/${props.match.params.vid}'`);
    axios.get(`/law/api/online-cle/OnlineCLE_Videos/${props.match.params.vid}`)
      .then(res => {
        console.log(res.data)
        setVideoDataRaw(res.data);
      })
      .catch(function (error) {
        console.log(error)
        setVideoDataRaw({ error: "Not Found" });
      });
  }, []);

  useEffect(() => {
    if (videoDataRaw) {
      console.log(`Fetching (GET) '/law/api/online-cle/law_CLECreditTypes'`);
      axios.get('/law/api/online-cle/law_CLECreditTypes')
        .then(res => {
          console.log(res.data);
          setVideoData({ ...videoDataRaw, CLECreditTypeName: res.data.length > 0 ? res.data.find(item => item.Id === videoDataRaw.CLECreditType).Name : "" });
        });
    }
  }, [videoDataRaw]);

  return (
    <MenuWithLogin title='Apply for CLE Credit' size="lg" loggedIn={props.loggedIn} setLoggedIn={props.setLoggedIn} handleLoginBoxOpen={props.handleLoginBoxOpen} handleSignOut={props.handleSignOut}>
      {videoData != null
        ?
        videoData.error
          ? <Typography variant="h2" component="h1">Error Loading Form</Typography>
          : <CLEForm vid={props.match.params.vid} {...videoData}></CLEForm>
        :
        <Typography variant="h2" component="h1">

        </Typography>
      }
      <div></div>
    </MenuWithLogin>
  );
}